import React from 'react';
import {SelectInput} from 'react-admin';

const type = [
    {id: 'Không', name: 'Không'},
    {id: 'Toán', name: 'Toán'},
    {id: 'KHTN (Lý)', name: 'KHTN (Lý)'},
    {id: 'KHTN (Hóa)', name: 'KHTN (Hóa)'},
    {id: 'KHTN (Sinh)', name: 'KHTN (Sinh)'},
    {id: 'KHTN', name: 'KHTN'},
    {id: 'Lịch sử - Địa lý', name: 'Lịch sử - Địa lý'},
    {id: 'Văn', name: 'Văn'},
    {id: 'Anh', name: 'Anh'},
    {id: 'Tin', name: 'Tin'},
    {id: 'Công nghệ', name: 'Công nghệ'},
    {id: 'KHKT', name: 'KHKT'}
]

export const HsGioiInput = (props) => (
    <SelectInput source={props.source} choices={type} {...props} />
)
